const swsConfig = document.head.querySelector('[name~=sws_config][content]');
const jsonString = swsConfig ? atob(swsConfig.getAttribute('content')) : JSON.stringify({});
const {
    env,
    google_analytics_mount_event_name,
    profile_loaded_event_name,
    sessions_service,
    showRecentsEnabled,
    allowPolyFill,
    onetrustCookiesExist,
    onetrustToken,
    webservices_root,
    notificationsServiceRootUrl,
    notificationsEnabled,
    welcomeToastBlacklist,
    assets_root
} = JSON.parse(jsonString);

const config = {
    env,
    assets_root,
    sessions_service,
    webservices_root,
    notificationsServiceRootUrl,
    notificationsEnabled,
    allowPolyFill: allowPolyFill || document.cookie.includes('allow-polyfills'),
    // ↓ depreciated
    onetrustCookiesExist: onetrustCookiesExist || (document.cookie.includes('OptanonConsent') && document.cookie.includes('OptanonAlertBoxClosed')),
    onetrustToken: onetrustToken,
    profileLoadedEventName: profile_loaded_event_name || 'sws_profile_loaded',
    // google analytics
    googleAnalytics: {
        hasMountedEventName: google_analytics_mount_event_name || 'sws_google_analytics_has_mounted',
        javascriptFile: '',
        /*env === 'production'
                ? 'https://www.google-analytics.com/analytics.js'
                : 'https://www.google-analytics.com/analytics_debug.js',*/
    },
    welcomeToastBlacklist: welcomeToastBlacklist || ['/myaccount', '/checkout'],

    // templating
    footer: {},
    header: {
        showRecentsEnabled: showRecentsEnabled || false,
    },
};

export default config;
